import KapService from "../../services/keanggotaan/kap.service";

export const Kap = {
  data() {
    return {
      optionKap : [],
      multi_kap : [],
      items_kap : [],
    };
  },
  methods: {
    getAllKap() {
        KapService.getKap(0,100000,'default')
        .then(response => {
            this.optionKap = response.data.data.content
            this.items_kap = response.data.data.content 
        }).catch(error => {
            // comment console console.log(error)
        })
    }
  }
};